import { render, staticRenderFns } from "./CookieAlert.vue?vue&type=template&id=ce84817c&scoped=true&"
import script from "./CookieAlert.vue?vue&type=script&lang=js&"
export * from "./CookieAlert.vue?vue&type=script&lang=js&"
import style0 from "./CookieAlert.vue?vue&type=style&index=0&id=ce84817c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce84817c",
  null
  
)

export default component.exports